import React from 'react';
import { Helmet } from 'react-helmet';

import { inject } from 'mobx-react';

import { isIE10 } from '../../helpers/browser-detection';

// import config from '../../data/config';

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    fullscreen: stores.ui.fullscreen,
});

export const Head = inject(mapper)(({ intl, fullscreen }) => (
    <Helmet>

        {isIE10() ? (
            <script src="https://cdnjs.cloudflare.com/ajax/libs/core-js/2.6.1/core.min.js"></script> 
        ): (null)}

        <style type="text/css">
        {`
            html, body {
                height: 100%;
                ${fullscreen ? `
                    overflow: hidden;
                `: ``}
            }

            #root {
                min-height: 100%;
                display: flex;
                flex:1;
                flex-direction: column;
                overflow: hidden;
            }
        `}
        </style>
        
    </Helmet>
));
